<template>
  <div class="withdrawal">
    <div class="title">{{ this.$store.state.titles }}</div>
    <div class="main ">
      <span class="cjje">
        总金额：<span>{{ getTotalAmount ? getTotalAmount : "0" }}</span
        >元
      </span>
      <span class="cjje">
        可提现金额：<span>{{
          getWithdrawableCash ? getWithdrawableCash : "0"
        }}</span
        >元
      </span>
      <span style="margin-left: 30px">
        <el-button type="primary" @click="dialogFormVisible = true"
          >提现</el-button
        >
      </span>
      <div class="tishi">
        <p>提现之后，平台工作人员将在24小时内审核</p>
      </div>
      <div class="table">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="提现记录" name="sj">
            <list ref="child1" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog title="提现" width="30%" :visible.sync="dialogFormVisible">
      <div class="tixian">
        <div class="titles">
          提现金额<span>{{ getWithdrawableCash }}</span
          >元
        </div>
        <el-form> </el-form>
        <div class="item">
          <el-select
            style="width: 100%"
            v-model="customer"
            placeholder="请选择"
            :disabled="!isAccount"
            @change="changeSel"
          >
            <el-option
              v-for="item in customers"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            >
            </el-option>
          </el-select>
        </div>
        <div class="item">
          <el-input clearable disabled v-model="AccountName"></el-input>
        </div>
        <p class="tips_text" v-if="!isAccount">
          温馨提示： 您当前没有设置提现账户，请前往
          <router-link to="/account" class="tips_link">账户信息</router-link>
          设置
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="getApplyWithdrawal"
          :loading="isSubLoading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import list from "./component/list";
export default {
  data() {
    return {
      // 帐户名称
      isSubLoading: false,
      AccountName: "未设置",
      // 是否设置提现帐户
      isAccount: false,
      // 总金额
      totalAmount: 0,
      // 可提现金额
      withdrawableCash: 0,
      activeName: "sj",
      puroductName: "",
      customer: null,
      customers: [
        {
          value: "wx",
          label: "微信",
          disabled: false,
        },
        {
          value: "ali",
          label: "支付宝",
          disabled: false,
        },
      ],
      dialogFormVisible: false,
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
    ...mapGetters(["getUserInfo"]),
    ...mapGetters(["getAccountWx"]),
    ...mapGetters(["getAccountAli"]),
    ...mapGetters(["getTotalAmount"]),
    ...mapGetters(["getWithdrawableCash"]),
  },
  components: {
    list,
  },
  created() {
    let opt = {
      token: this.getToken,
      reviewer_status: 1, //审核状态(固定写1)
    };
    //
    this.getUserInfoApi(opt).then((res) => {
      if (res.data.code === 1) {
        this.setUserInfo(res.data.data);
      }
    });
    if (this.getAccountWx == "" && this.getAccountWx == null) {
      this.customers[0].disabled = true;
    } else {
      this.customers[0].disabled = false;
    }

    if (this.getAccountAli == "" && this.getAccountAli == null) {
      this.customers[1].disabled = true;
    } else {
      this.customers[1].disabled = false;
    }

    if (
      this.getAccountWx == "" &&
      this.getAccountWx == null &&
      this.getAccountAli == "" &&
      this.getAccountAli == null
    ) {
      this.isAccount = false;
    } else {
      this.isAccount = true;
    }

    // 获取总金额和可提现金额
    this.getWithdrawable({ token: this.getToken })
      .then((res) => {
        // console.log(res);
        if (res.data.code === 1) {
          this.setWithdrawableCash(res.data.data.deduction_withdraw);
          this.setTotalAmount(res.data.data.all);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    ...mapActions({
      getWithdrawable: "loginModule/getWithdrawable",
      getUserInfoApi: "loginModule/getUserInfoApi",
      applyWithdrawal: "loginModule/applyWithdrawal",
    }),
    ...mapMutations({
      setUserInfo: "setUserInfo",
      setWithdrawableCash: "setWithdrawableCash",
      setTotalAmount: "setTotalAmount",
    }),
    handleClick(tab, event) {
      if (tab.label == "商品库") {
        this.puroductName = "";
      }
    },
    getApplyWithdrawal() {
      this.isSubLoading = true;
      let opt = {
        token: this.getToken,
        type: this.customer,
        amount: this.getWithdrawableCash.toString(),
      };
      this.applyWithdrawal(opt)
        .then((res) => {
          // console.log(res);
          if (res.data.code === 1) {
            this.$message.success(res.data.data.msg);
            this.$refs.child1.refreshList();
          } else {
            this.$message.error(res.data.msg);
          }
          this.dialogFormVisible = false;
          this.isSubLoading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeSel(val) {
      if (val == "wx") {
        this.AccountName = this.getAccountWx;
      } else if (val == "ali") {
        this.AccountName = this.getAccountAli;
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.tixian {
  width: 60%;
  margin: 0 auto;
  .titles {
    width: 100%;
    font-size: 20px;
    text-align: center;
    span {
      padding: 0 5px;
      color: #e72f0d;
      font-size: 25px;
    }
  }
  .item {
    margin-top: 20px;
  }
}
.cjje {
  font-size: 16px;
  color: #333;
  margin-left: 32px;
  &:first-child {
    margin-left: 100px;
    span {
      color: #2448ff;
    }
  }
  span {
    color: #e72f0d;
    padding: 0 5px;
  }
}
.title {
  box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
  width: 100%;
  background: #fff;
  font-size: 20px;
  color: #000000;
  width: 100%;
  padding: 15px 32px;
}
::v-deep .el-tabs__item {
  padding: 0 42px !important;
}
::v-deep .el-tabs__active-bar {
  width: 126px !important;
  left: -43px;
}
.main {
  box-shadow: 0px 0px 8px 0px rgba(100, 100, 100, 0.17);
  background: #fff;
  margin: 24px;
  padding: 20px 10px;
  padding-bottom: 70px;
  min-width: 1200px;
  span {
    margin-right: 10px;
    ::v-deep .el-input {
      width: 150px;
      display: inline-block;
    }
  }
  .table {
    margin-top: 40px;
  }
}

.tips_text {
  margin-top: 15px;
  font-size: 14px;
}
.tips_link {
  color: red;
}

.dialog-footer {
  display: flex;
  justify-content: center;
}

.tishi {
  margin-left: 100px;
  p {
    font-size: 14px;
    color: #999;
  }
}
</style>